import React from 'react';
import {GoogleMap, Polygon, withGoogleMap, withScriptjs} from "react-google-maps";
import SearchBox from "react-google-maps/lib/components/places/SearchBox";
import PropTypes from 'prop-types';

export const calculateDiff = (boxSize, boxScale) => {
    return boxSize * boxScale / (2 * 1200); // boxSize / 2 is the distance from center to border boxSize / 1200 is the resolution of 3"
};

const MyMapComponent = withScriptjs(withGoogleMap((props) => {
    const {initialLat, initialLng, initialZoom, onClick, boxSize, boxScale, onDragEnd} = props;

    this.lat = initialLat;
    this.lng = initialLng;

    // this is used to handle the distortion from dragging when not dragging the center of the polygon
    this.latDiff = 0;
    this.lngDiff = 0;

    this.refs = {};

    this.calculatePolygonBasedOnCenter = (lat, lng, boxSize, boxScale) => {
        const d = calculateDiff(boxSize, boxScale);

        return [
            {lat: lat + d, lng: lng - d}, // SW
            {lat: lat + d, lng: lng + d}, // SE
            {lat: lat - d, lng: lng + d}, // NE
            {lat: lat - d, lng: lng - d} // NW
        ];
    };

    this.handleOnClick = (e) => {
        const lat = e.latLng.lat();
        const lng = e.latLng.lng();

        this.lat = lat;
        this.lng = lng;

        onClick(lat, lng)
    };

    this.onDragStart = (lat, lng) => {
        this.latDiff = this.lat - lat;
        this.lngDiff = this.lng - lng;
    };

    this.onPlacesChanged = () => {
        const newLocation = this.refs.searchBox.getPlaces()[0];

        if (newLocation) {
            const latlng = newLocation.geometry.location;

            this.lat = latlng.lat();
            this.lng = latlng.lng();

            const bounds = new window.google.maps.LatLngBounds();
            const polygon = this.calculatePolygonBasedOnCenter(this.lat, this.lng, boxSize, boxScale);
            polygon.map((point) => bounds.extend(point));

            this.refs.map.fitBounds(bounds);

            onClick(this.lat, this.lng);
        }
    };

    return (
        <GoogleMap
            defaultZoom={initialZoom}
            defaultCenter={{lat: initialLat, lng: initialLng}}
            ref={(ref) => this.refs.map = ref}
            onClick={this.handleOnClick}
            options={{
                clickableIcons: false,
                streetViewControl: false,
                mapTypeControl: false,
                mapTypeId: "terrain"
            }}
        >
            <SearchBox
                ref={(ref) => this.refs.searchBox = ref}
                controlPosition={window.google.maps.ControlPosition.TOP_LEFT}
                onPlacesChanged={this.onPlacesChanged}
            >
                <input
                    type="text"
                    placeholder="Search..."
                    style={{
                        boxSizing: `border-box`,
                        border: `1px solid transparent`,
                        width: `240px`,
                        height: `32px`,
                        padding: `0 12px`,
                        borderRadius: `3px`,
                        boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
                        fontSize: `14px`,
                        outline: `none`,
                        textOverflow: `ellipses`,
                    }}
                />
            </SearchBox>
            <Polygon
                path={this.calculatePolygonBasedOnCenter(initialLat, initialLng, boxSize, boxScale)}
                defaultDraggable={true}
                onDragStart={(e) => this.onDragStart(e.latLng.lat(), e.latLng.lng())}
                onDragEnd={(e) => onDragEnd(e.latLng.lat() + this.latDiff, e.latLng.lng() + this.lngDiff)}
                onClick={this.handleOnClick}
            />
        </GoogleMap>
    );
}));

const Map = (props) => {

    const {boxSize, boxScale, defaultZoom, lat, lng, onBoxChanged} = props;

    return (
        <MyMapComponent
            initialLat={lat}
            initialLng={lng}
            initialZoom={defaultZoom}
            boxSize={boxSize}
            boxScale={boxScale}
            onZoomChanged={this.onZoomChanged}
            onDragEnd={onBoxChanged}
            onClick={onBoxChanged}
            googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_API_KEY}&v=3.exp&libraries=geometry,drawing,places`}
            loadingElement={<div style={{height: `100%`}}/>}
            containerElement={<div style={{height: `100%`}}/>}
            mapElement={<div style={{height: `100%`}}/>}
        />
    );

};

Map.propTypes = {
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired,
    defaultZoom: PropTypes.number.isRequired,
    boxSize: PropTypes.number.isRequired,
    boxScale: PropTypes.number.isRequired,

    onBoxChanged: PropTypes.func.isRequired
};

export default Map;



// WEBPACK FOOTER //
// ./src/common/Map/Map.js